import axios from "axios";
import { ElMessage } from "element-plus";
import router from "@/router";

let isRefreshing = false;
let refreshSubscribers = [];

// 当多个请求同时遇到401时，等待新的token再继续请求
function subscribeTokenRefresh(cb) {
  refreshSubscribers.push(cb);
}

function onRrefreshed(token) {
  refreshSubscribers.forEach((cb) => cb(token));
  refreshSubscribers = [];
}

async function refresh(response) {
  const originalRequest = response.config;

  if (!isRefreshing) {
    isRefreshing = true;
    try {
      const newToken = await refreshAccessToken(); // 🔁 刷新 token
      isRefreshing = false;
      onRrefreshed(newToken); // 通知等待中的请求

      // 重新请求
      originalRequest.headers.Authorization = `Bearer ${newToken}`;
      return service(originalRequest);
    } catch (e) {
      isRefreshing = false;
      ElMessage.error("登录已过期，请重新登录");
      router.push("/login");
      return Promise.reject(e);
    }
  } else {
    // 等待刷新完成再继续
    return new Promise((resolve) => {
      subscribeTokenRefresh((token) => {
        originalRequest.headers.Authorization = `Bearer ${token}`;
        resolve(service(originalRequest));
      });
    });
  }
}

const service = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 10000,
  withCredentials: true, // 让 refreshToken cookie 自动携带
});

// 请求拦截：自动带 accessToken
service.interceptors.request.use((config) => {
  const token = localStorage.getItem("accessToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// 响应拦截
service.interceptors.response.use(
  async (response) => {
    if (!response.data) {
      ElMessage.error("null response");
      return Promise.resolve(null);
    } else if (
      response.data.code === 401 &&
      response.data.msg === "jwt expired"
    ) {
      await refresh(response);
    } else if (response.data.code !== 200) {
      ElMessage.error(response.data.msg);
      return Promise.resolve(null);
    } else if (!response.data.data || !response.data.data.params) {
      ElMessage.error("invalid response");
      return Promise.resolve(null);
    }
    return Promise.resolve(response.data.data.params);
  },
  async (error) => {
    // eslint-disable-next-line
    if (error.code === "ERR_NETWORK") {
      ElMessage.error(error.message);
      return Promise.resolve(null);
    }

    // 其他错误
    ElMessage.error(error.response?.data?.message || "请求失败");
    return Promise.resolve(null);
  }
);

// 刷新 token 方法
async function refreshAccessToken() {
  const res = await axios.post(
    process.env.VUE_APP_API_URL,
    {
      method: "manager.refreshToken",
    },
    { withCredentials: true }
  );
  const newToken = res.data?.data?.params?.accessToken;
  if (newToken) {
    localStorage.setItem("accessToken", newToken);
    return newToken;
  }
  throw new Error("刷新失败");
}

export async function apiCall(method, params = {}) {
  return service({
    url: process.env.VUE_APP_API_URL,
    method: "POST",
    data: {
      method,
      params,
    },
  });
}

export async function apiUploads(formData) {
  return await service.post(process.env.VUE_APP_API_URL + "uploads", formData, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 10 * 60 * 1000,
  });
}

export async function apiUpload(formData) {
  return await service.post(process.env.VUE_APP_API_URL + "upload", formData, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 10 * 60 * 1000,
  });
}
